const baseExtras = (overrides = {}) => ({
  heating: 'Doğalgaz · Kombi',
  buildingAge: '2',
  floor: '5 / 8',
  totalFloors: '8',
  bathroom: '2',
  balcony: '2',
  parking: 'Kapalı Otopark · 2 araçlık',
  furniture: 'Eşyalı Değil',
  facade: 'Güney - Doğu',
  creditEligible: 'Krediye Uygun',
  deedStatus: 'Kat Mülkiyeti',
  usage: 'Boş',
  swap: 'Takas Yok',
  site: 'Site İçi · 7/24 Güvenlik',
  dues: '₺ 1.200 / ay',
  buildingType: 'Betonarme',
  features: ['Asansör', 'Güvenlik', 'Site İçi', 'Yüzme Havuzu', 'Spor Salonu', 'Çocuk Oyun Alanı'],
  description:
    'Lara bölgesinin en gözde lokasyonunda yer alan, panoramik deniz manzaralı, premium işçilikli daire. Geniş ferah salon, ankastre mutfak ve master yatak odası ebeveyn banyosu ile sunulmuştur. Akıllı ev altyapısı, smart aydınlatma ve klima sistemleri mevcuttur.',
  ...overrides,
});

export const properties = [
  {
    id: 'p001',
    code: 'DEO-2401',
    title: 'Lüks Deniz Manzaralı Rezidans',
    location: 'Lara · Antalya',
    type: 'Premium Rezidans',
    price: '₺ 24.500.000',
    size: '185',
    rooms: '4+1',
    aiScore: '94',
    image: 'https://images.unsplash.com/photo-1613977257363-707ba9348227?auto=format&fit=crop&w=1200&q=85',
    highlights: ['%18 Kira Getirisi', 'Deniz Manzarası', 'Hemen Teslim'],
    extras: baseExtras({
      heating: 'Yerden Isıtma · Kombi',
      buildingAge: '1',
      floor: '12 / 16',
      totalFloors: '16',
      bathroom: '2',
      balcony: '3',
      parking: 'Kapalı Otopark · 2 araçlık',
      furniture: 'Lüks Eşyalı',
      facade: 'Güney - Deniz',
      features: ['Asansör', 'Concierge', 'Spa', 'Yüzme Havuzu', 'Smart Home', 'Marina Erişimi'],
      dues: '₺ 4.500 / ay',
      description:
        'Lara sahil bandının en prestijli rezidansında, panoramik deniz manzaralı 4+1 daire. Smart home altyapısı, yerden ısıtma, ankastre Miele ürünleri ve özel concierge hizmetiyle sunulmaktadır. Marina ve plaja yürüme mesafesi.',
    }),
  },
  {
    id: 'p002',
    code: 'DEO-2402',
    title: 'Modern Müstakil Villa',
    location: 'Konyaaltı · Antalya',
    type: 'Villa',
    price: '₺ 38.900.000',
    size: '420',
    rooms: '6+2',
    aiScore: '97',
    image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1200&q=85',
    highlights: ['Özel Havuzlu', 'Akıllı Ev Sistemi', 'Denize 200m'],
    extras: baseExtras({
      heating: 'Yerden Isıtma · Doğalgaz',
      buildingAge: '3',
      floor: 'Müstakil · 3 Kat',
      totalFloors: '3',
      bathroom: '4',
      balcony: '3 Teras',
      parking: 'Açık · 4 araçlık',
      furniture: 'Eşyasız',
      facade: '4 Cephe',
      site: 'Müstakil · Özel Bahçe',
      features: ['Özel Havuz', 'Bahçe', 'Smart Home', 'Sauna', 'Şömine', 'Hizmetli Dairesi'],
      dues: 'Aidatsız',
      description:
        'Konyaaltı sahile yürüyüş mesafesinde, 800 m² arsa üzerinde 3 katlı modern müstakil villa. Açık yüzme havuzu, peyzaj bahçe, sauna ve hizmetli dairesi mevcut. Akıllı ev sistemleri ve güneş enerjisi altyapısı kurulmuştur.',
    }),
  },
  {
    id: 'p003',
    code: 'DEO-2403',
    title: 'Premium Penthouse Süit',
    location: 'Muratpaşa · Antalya',
    type: 'Penthouse',
    price: '₺ 52.000.000',
    size: '310',
    rooms: '5+1',
    aiScore: '98',
    image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1200&q=85',
    highlights: ['Panoramik Manzara', 'Concierge Hizmet', 'Spa & Havuz'],
    extras: baseExtras({
      heating: 'Yerden Isıtma · VRF',
      buildingAge: '2',
      floor: '24 / 24 (Çatı)',
      totalFloors: '24',
      bathroom: '3',
      balcony: '2 Teras · 80 m²',
      parking: 'Kapalı · 3 araçlık',
      furniture: 'Designer Eşyalı',
      facade: '360° Panoramik',
      features: ['Özel Asansör', 'Concierge', 'Çatı Havuzu', 'Spa', 'Şarap Mahzeni', 'Helikopter Pisti Erişimi'],
      dues: '₺ 8.200 / ay',
      description:
        'Antalya merkezdeki en yüksek lüks kulenin çatısına yerleşmiş, 80 m² özel terasla birlikte 310 m² penthouse. 360° panoramik manzara, designer iç tasarım ve özel concierge hizmeti. Şehrin en ayrıcalıklı yaşamı.',
    }),
  },
  {
    id: 'p004',
    code: 'DEO-2404',
    title: 'Sahil Cepheli Rezidans',
    location: 'Belek · Antalya',
    type: 'Rezidans',
    price: '₺ 18.750.000',
    size: '165',
    rooms: '3+1',
    aiScore: '91',
    image: 'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&w=1200&q=85',
    highlights: ['%22 Kira Getirisi', 'Sahil Erişimi', 'Yatırımlık'],
    extras: baseExtras({
      heating: 'Kombi · Doğalgaz',
      buildingAge: '4',
      floor: '7 / 12',
      totalFloors: '12',
      bathroom: '2',
      balcony: '2',
      furniture: 'Eşyalı',
      facade: 'Güney - Deniz',
      features: ['Asansör', 'Güvenlik', 'Sahil Erişimi', 'Yüzme Havuzu', 'Spa', 'Çocuk Kulübü'],
      dues: '₺ 2.400 / ay',
      description:
        'Belek golf koridorunda, sahile özel iskele erişimi olan ödüllü rezidans projesinde 3+1 daire. Yıllık ortalama %22 kira getirisi sunan yatırımlık fırsat. Eşyalı teslim, anahtar teslim Airbnb yönetim opsiyonu mevcut.',
    }),
  },
  {
    id: 'p005',
    code: 'DEO-2405',
    title: 'Marina Manzaralı Loft',
    location: 'Kalkan · Antalya',
    type: 'Loft',
    price: '₺ 14.200.000',
    size: '142',
    rooms: '2+1',
    aiScore: '89',
    image: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=1200&q=85',
    highlights: ['Marina Manzaralı', 'Butik Yapı', 'Taş Köy Dokusu'],
    extras: baseExtras({
      heating: 'Klima · VRF',
      buildingAge: '5',
      floor: '3 / 3',
      totalFloors: '3',
      bathroom: '2',
      balcony: '1 Teras',
      furniture: 'Eşyalı',
      facade: 'Batı - Marina',
      buildingType: 'Taş + Betonarme',
      features: ['Marina Manzarası', 'Butik Yapı', 'Şömine', 'Özel Teras', 'Smart Home'],
      dues: '₺ 1.800 / ay',
      description:
        'Kalkan taş köy dokusunu modern mimariyle birleştiren butik projede, marina ve günbatımı manzaralı 2+1 loft. Yerel mimari detaylar korunmuş, üst kat teras şömineyle sunuluyor.',
    }),
  },
  {
    id: 'p006',
    code: 'DEO-2406',
    title: 'Özel Plajlı Köşk',
    location: 'Kemer · Antalya',
    type: 'Köşk',
    price: '₺ 67.500.000',
    size: '580',
    rooms: '7+3',
    aiScore: '96',
    image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=1200&q=85',
    highlights: ['Özel Plaj', 'Helikopter Pisti', 'Sınırsız Manzara'],
    extras: baseExtras({
      heating: 'Yerden Isıtma · Jeotermal',
      buildingAge: '6',
      floor: 'Müstakil · 2 Kat',
      totalFloors: '2',
      bathroom: '6',
      balcony: '4 Teras',
      parking: 'Açık · 6 araçlık',
      furniture: 'Designer Eşyalı',
      facade: '4 Cephe',
      creditEligible: 'Krediye Uygun · 70% LTV',
      site: 'Müstakil · 4.000 m² Arsa',
      features: ['Özel Plaj', 'Helikopter Pisti', 'Misafir Evi', 'Sauna & Hamam', 'Şarap Mahzeni', 'Tenis Kortu'],
      dues: 'Aidatsız',
      description:
        'Kemer doğal SİT alanı içinde, 4.000 m² özel arazi üzerinde, denize sıfır cepheli, 100 m özel plaj kullanımına sahip lüks köşk. Helikopter pisti, misafir evi, jeotermal ısıtma sistemleri. Pazarlama Türkiye geneli özel müşteri ağıyla yapılır.',
    }),
  },
];

export const stats = [
  { label: 'Aktif Portföy', value: '247', delta: '+12' },
  { label: 'Toplam Değer', value: '₺ 4.8B', delta: '+8.2%' },
  { label: 'AI Eşleşme', value: '1,284', delta: 'bu ay' },
  { label: 'Ort. Kira Getirisi', value: '%14.7', delta: '+2.1%' },
];
